import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { MessageService } from '../../core/service/message.service';
import { UserService } from '../../core/service/user.service';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { NGXLogger } from 'ngx-logger';
import { User } from 'src/app/user/model/user';
import { Message } from '../../case/model/message';
import { IntlService } from '@progress/kendo-angular-intl';

@Component({
  selector: 'app-message-detail',
  templateUrl: './message-detail.component.html',
  styleUrls: ['./message-detail.component.scss']
})

export class MessageDetailComponent implements OnChanges
{
  @Input() public message: Message;
  @Input() public messageList: any;
  @Input() public type: string;

  @Output() public completed = new EventEmitter<string>();

  public selectedMessage: Message;
  public username = this.authenticationService.isAuthenticated ? this.authenticationService.currentUser.userName : null;
  public messageReplyOpened = false;
  public fromUser: User;
  public isDataAvailable = false;
  public body = '';
  public url: string;
  public imageLoaded = false;
  public hasImage = false;
  public userInitials = '';
  public errorMessage: string;
  public all = false;
  public isReplyVisible = false;

  constructor(
    private messageService: MessageService,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private logger: NGXLogger,
    public intl: IntlService) { }

  public ngOnChanges(): void
  {
    this.loadMessage();
  }

  public reply(): void
  {
    this.all = false;
    setTimeout(() => { this.messageReplyOpened = true; });
  }

  public replyAll(): void
  {
    this.all = true;
    setTimeout(() => { this.messageReplyOpened = true; });
  }

  private loadMessage(): any
  {
    this.messageReplyOpened = false;
    let messageToContainsCurrentUser = false;
    // get message info
    return this.messageService.getMessageById(this.message.id).subscribe({
      next: (data) =>
      {
        data.from = data.fromDirectAddress ? data.fromDirectAddress : data.from;
        this.selectedMessage = data;
        if (this.selectedMessage.body !== null)
        {
          this.body = this.selectedMessage.body;
          this.body = this.body.replace(/[\n\r]/g, '<br/>');
        }
        else
        {
          this.body = null;
        }
        this.getPhotoFromService();
        this.isDataAvailable = true;
        data.to.forEach((d: any) =>
        {
          if (!messageToContainsCurrentUser && d.username === this.authenticationService.currentUser.userName)
          {
            messageToContainsCurrentUser = true;
          }
        });
        this.isReplyVisible = (data.fromUsername === this.authenticationService.currentUser.userName) || messageToContainsCurrentUser;
      },
      error: (error) =>
      {
        this.logger.error(error);
      }
    });
  }

  private getPhotoFromService()
  {
    this.imageLoaded = false;
    this.hasImage = false;
    this.userService.getCachedPhotoUser(this.selectedMessage.fromUsername).subscribe({
      next: (data) =>
      {
        this.hasImage = data.imageContent !== null;
        if (this.hasImage)
        {
          const base64 = data.imageContent;
          this.url = 'data:image/jpeg;base64,' + base64;
        }
        else
        {
          const splitted = this.selectedMessage.from.split(' ');
          this.userInitials = (splitted.length >= 2) ? `${splitted[0].charAt(0)}${splitted[1].charAt(0)}` : null;
        }
        this.imageLoaded = true;
      },
      error: (error) =>
      {
        this.logger.error(error);
        this.errorMessage = error.message;
      }
    });
  }
}
